import {memo} from "react";
import AdminPanel from "../components/Chat/AdminPanel";
import useDocumentTitle from "../hooks/useDocumentTitle";

const Admin = memo(function Admin() {
  useDocumentTitle("admin");

  return (
    <div className="bg-black min-h-screen">
      <AdminPanel />
    </div>
  );
});

export default Admin;
